import request from "@utils/request";

export function chinaresidents(data) {
  return request.get(
      "/insurance/nosignature", 
      data, 
      { login: false }
    );
}
1